import { APIcallerv2 } from './APIcaller';

/** sentAt (raw timestamp, resolved server-side in the store timezone) takes precedence over date. */
const getSupplierProductsAndRecipesByStoreId = (storeId, { date = null, sentAt = null } = {}) =>
  APIcallerv2.apiGet(`/transfers/store/${storeId}/supplier-products-recipes`, {
    ...(date ? { date } : {}),
    ...(sentAt ? { sentAt } : {}),
  });

const getTransferListById = (transferListId) =>
  APIcallerv2.apiGet(`/transfers/${transferListId}/details`);

const createTransfer = ({ transferList, supplierProducts, recipes }) =>
  APIcallerv2.apiPost('/transfers/create', { transferList, supplierProducts, recipes });

const updateTransferDeliveryNote = ({ transferList, supplierProducts, recipes }) =>
  APIcallerv2.apiPost('/transfers/delivery-note', { transferList, supplierProducts, recipes });

const updateTransferReception = ({ transferList, supplierProducts, recipes }) =>
  APIcallerv2.apiPost('/transfers/reception', { transferList, supplierProducts, recipes });

export default {
  getSupplierProductsAndRecipesByStoreId,
  getTransferListById,
  createTransfer,
  updateTransferDeliveryNote,
  updateTransferReception,
};
